export default __webpack_public_path__ + "static/media/twitter.21076a4b.svg";